<ng-container *ngIf="!!_widgetData">
      <div class="section-header" *ngIf="!!displayHeader">{{widgetHeader | translate}}</div>
      <gen-tabs-header
              (tabChange)="tabChanged($event)"
              (tabInit)="tabInit($event)"
              [styleModifier]="'info-section-headers ' + tabsHeaderCss"
              [currentTab]="selectedTab"
              [tabs]="tabsHeaders">
      </gen-tabs-header>
      <ng-container *ngFor="let content of tabsContents; let tabIndex = index; trackBy: trackByFn">
        <ng-container *ngIf="tabsHeaders[tabIndex].name === selectedTab">
          <gen-dynamic-form
                  [formData]="widgetData[selectedTab]"
                  [formName]="content"
                  [listenToDataChange]="true"
                  [formItemFullWidth]="formFullWidth[tabIndex]"
                  [additionalSearchValues]="additionalSearchValues"
                  (formChange)="tabCommunicates($event)"
          ></gen-dynamic-form>
        </ng-container>
      </ng-container>
</ng-container>